// extracted by mini-css-extract-plugin
module.exports = {"cover":"Cover-module--cover--GwjK5","imageSmallInFrame":"Cover-module--imageSmallInFrame--ylqV9"};